import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/preview/styles.scss';export default {
  "preview": "_preview_10v48_1",
  "loader": "_loader_10v48_12"
};